import * as constants from './actions';

import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    isSubmitting: false
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.PETITION_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.PETITION_CANCELLED:
            return {
                ...state,
                actionCancelled: true,
                actionCancelledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.PETITION_SUCCESS:
            return {
                ...state,
                completePetition: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                actionInitiated: false
            };
        case constants.PETITION_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.PETITION_ERROR:
            return {
                ...state,
                petitionError: payload
            };
        case constants.OVERLAY_PETITION_VISIBLE:
            return { ...state, isOverlayPetitionVisible: payload };
        default:
            return state;
    }
}
